import React from 'react'

export default function ShareOutlineIcon({
  className = '',
  width = 18,
  height = 22,
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M9 1V14M5 5L9 1L13 5M1 11V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V11" stroke="#1E3E85" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
